import parsePhoneNumberFromString, { isPossiblePhoneNumber } from "libphonenumber-js";
import { DocumentDTO, GlobalPeopleSearchDTO, PermissionType } from "../store/generatedFetchClient";
import { GraphData } from "./metrics";
//Stick in any custom helper methods here
// Break them out into separate files when this gets too large

let UUID = 0;
export function UniqueId() {
  const getId = () => {
    UUID++;
    return UUID.toString();
  };
  return { getId };
}

export function ToSystemName(label: string) {
  label = label.toLocaleLowerCase();
  label = label.replace(" ", "-");
  return label;
}

export function formatDateTime(date: any) {
  var dateString = date.toString();
  dateString = dateString.includes("Z") ? dateString : dateString + "Z";
  let newDate = new Date(dateString);
  // let [, tzName] = /.*\s(.+)/.exec(
  //   new Date().toLocaleDateString(navigator.language, { timeZoneName: "short" })
  // );
  let formatedDate = Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "numeric",
    day: "numeric",

    hour: "numeric",
    minute: "numeric",
    timeZoneName: "short",
  }).format(newDate);

  return formatedDate === "Invalid Date" ? "" : formatedDate;
}

export function fromAgo(isoTimestamp: string): string {
  const ms = Date.now() - new Date(isoTimestamp).getTime();

  const seconds = Math.round(ms / 1000);
  const minutes = Math.round(ms / 60000);
  const hours = Math.round(ms / 3600000);
  const days = Math.round(ms / 86400000);
  const months = Math.round(ms / 2592000000);
  const years = Math.round(ms / 31104000000);

  switch (true) {
    case seconds < 60:
      return `${seconds} second(s) ago`;
    case minutes < 60:
      return `${minutes} minute(s) ago`;
    case hours < 24:
      return `${hours} hour(s) ago`;
    case days < 30:
      return `${days} day(s) ago`;
    case months < 12:
      return `${months} month(s) ago`;
    default:
      return `${years} year(s) ago`;
  }
}

export function formatPhoneNumber(phoneNumber: string): string {
  if (phoneNumber != null) {
    const parsedNumber = parsePhoneNumberFromString(phoneNumber, "US");

    if (parsedNumber != undefined) {
      if (parsedNumber.country == "US") return parsedNumber.format("NATIONAL");
      else return parsedNumber.format("INTERNATIONAL");
    }
  }
  return "";
}

export function validateUnrequiredPhoneNumber(phoneNumber: string): boolean {
  if (phoneNumber == null || phoneNumber.length == 0) return true;
  return isPossiblePhoneNumber(phoneNumber, "US");
}

export const recentPortalsKey = "recentPortals";
export function addToRecentlyUsedPortals(portalId: number) {
  let recentPortals: number[] = getRecentlyUsedPortals();
  if (recentPortals.includes(portalId)) {
    recentPortals.unshift(recentPortals.splice(recentPortals.indexOf(portalId), 1)[0]);
    localStorage[recentPortalsKey] = JSON.stringify(recentPortals);
  } else {
    recentPortals.unshift(portalId);
    if (recentPortals.length > 10) recentPortals.pop();
    localStorage[recentPortalsKey] = JSON.stringify(recentPortals);
  }
}

export function getRecentlyUsedPortals(): number[] {
  return JSON.parse(localStorage.getItem(recentPortalsKey) ?? "[]");
}

export const recentUsersKey = "recentUsers";
export function addToRecentlyUsedUsers(user: GlobalPeopleSearchDTO) {
  let recentUsers: GlobalPeopleSearchDTO[] = getRecentlyUsedUsers();
  if (recentUsers.map((u) => u.personId).includes(user.personId)) {
    recentUsers.unshift(
      recentUsers.splice(recentUsers.map((u) => u.personId).indexOf(user.personId), 1)[0]
    );
    localStorage[recentUsersKey] = JSON.stringify(recentUsers);
  } else {
    recentUsers.unshift(user);
    if (recentUsers.length > 10) recentUsers.pop();
    localStorage[recentUsersKey] = JSON.stringify(recentUsers);
  }
}

export function getRecentlyUsedUsers(): GlobalPeopleSearchDTO[] {
  return JSON.parse(localStorage.getItem(recentUsersKey) ?? "[]");
}

export function cleanString(dirtyString: string): string {
  return dirtyString.replaceAll(/[\ \'\.\,\&\n]/g, "");
}

const userStorageKey = "_user";
export function cacheDocuments(documents: DocumentDTO[], siteCode: string) {
  if (siteCode == null || siteCode.trim().length == 0) {
    console.error("Document cache sitecode is empty. Document caching canceled.");
    return;
  }

  var cachedUser = JSON.parse(localStorage.getItem(siteCode + userStorageKey) || "{}");
  var authToken = cachedUser?.token;

  if (authToken == null || authToken.trim().length == 0) {
    console.error("Can't find user's auth token. Document caching canceled.");
    return;
  }

  console.log("cachedocs cachedUser", cachedUser);

  let documentURLs = documents
    .filter(
      (doc) =>
        doc.allowAnonDownload ||
        (cachedUser?.siteRoleId != null &&
          doc.siteRoles?.map((s) => s.siteRoleId).includes(cachedUser?.siteRoleId) &&
          (!cachedUser?.isEmailVerificationRequired || cachedUser?.isEmailVerified))
    )
    .map((doc) => {
      return {
        url: `/api/Property/document/${doc.documentId}/download?token=${authToken}`,
        version: doc.version,
      };
    });

  if ("caches" in window) {
    console.log("Docs to be cached: ", documentURLs);
    console.log("Loading docs for offline storage");
    var docCacheName = siteCode + "_docList";
    var docCacheStatusName = docCacheName + "_status";

    type DocStatus = { url: string; version: number };
    var docCacheStatuses = JSON.parse(
      localStorage.getItem(docCacheStatusName) ?? "[]"
    ) as DocStatus[];

    caches.open(docCacheName).then(async function (cache) {
      await Promise.all(
        documentURLs.map(async (doc) => {
          // Only do new fetch if status for doc does not exist, or doc version is newer than the status
          if (
            !docCacheStatuses.some((docStatus) => docStatus.url == doc.url) ||
            docCacheStatuses.some(
              (docStatus) => docStatus.url == doc.url && doc.version! > docStatus.version
            )
          ) {
            try {
              let fetchObject = await fetch(doc.url);
              if (fetchObject.ok) {
                // Remove old status
                var index = docCacheStatuses.findIndex((docStatus) => docStatus.url == doc.url);

                if (index > -1) {
                  docCacheStatuses.splice(index, 1);
                }

                var cachedResponse = await cache.put(doc.url, fetchObject);

                //Create new status
                docCacheStatuses.push({ url: doc.url, version: doc.version! });

                return cachedResponse;
              } else {
                if (fetchObject.status == 401) {
                  console.warn(
                    "document fetch unsuccessful: " + doc.url + " (" + fetchObject.status + ")"
                  );
                } else {
                  console.error(
                    "document fetch unsuccessful: " + doc.url + " (" + fetchObject.status + ")"
                  );
                }
              }
            } catch (error: any) {
              console.error("document cache failed: " + doc.url, error);
            }
          }
        })
      );
      localStorage.setItem(docCacheStatusName, JSON.stringify(docCacheStatuses));
      console.log("set in local storage");
    });
  }
}

export function getPermissionTypeString(permissionType: PermissionType): string {
  switch (permissionType) {
    case PermissionType.ViewTrainingReport:
      return "Can View Training Report";
    case PermissionType.ViewPortalRoster:
      return "Can View Portal Roster";
    case PermissionType.ViewMobilityReport:
      return "Can View Mobility Report";
    case PermissionType.ViewVRReport:
      return "Can View VR Report";
    case PermissionType.ViewVRFilterReport:
      return "Can View VR Filter Report";
    case PermissionType.ViewTenantContactReport:
      return "Can View Tenant Contact Report";
    case PermissionType.ViewUsers:
      return "Can View Users";
    case PermissionType.EditDocuments:
      return "Can Edit Documents";
    case PermissionType.EditContacts:
      return "Can Edit Contacts";
    case PermissionType.ViewAlertSubscriptions:
      return "Can View Alert Subscriptions";
    case PermissionType.SendAlerts:
      return "Can Send Alerts";
    default:
      return PermissionType[permissionType];
  }
}

export function getSubdomain(url: URL): string {
  var hostname = url.hostname;
  var regex = new RegExp(/^([a-z]+\:\/{2})?([\w-]+\.[\w-]+\.\w+)$/);

  if (!!hostname.match(regex)) {
    let domain = hostname;
    if (hostname.includes("://")) {
      domain = hostname.split("://")[1];
    }
    const subdomain = domain.split(".")[0];
    return subdomain;
  } else return "";
}

export function isOnQAOrLocal(url?: URL): boolean {
  url = url || new URL(window.location.origin);
  return getSubdomain(url).length > 0 || url.hostname.startsWith("localhost");
}

let k = 1024;
let sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
export function formatBytes(bytes: number, decimals: number = 1): string {
  if (bytes == 0) return "0 Bytes";

  let i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + " " + sizes[i];
}

export const timeFrameOptions = [
  { name: "Past 24 Hours", value: 1 },
  { name: "Past Week", value: 7 },
  { name: "Past 2 Weeks", value: 14 },
  { name: "Past 4 Weeks", value: 28 },
  { name: "Past 24 Weeks", value: 168 },
  { name: "Past Year", value: 365 },
];

export function fillMissingDates(graphData: GraphData): GraphData {
  let { dates, dataSeries } = graphData;
  if (dates.length === 0) return { dates: [], dataSeries: [] };

  const filledDates: Date[] = [];
  const filledDataSeries: number[][] = [];
  for (let j = 0; j < dataSeries.length; j++) filledDataSeries.push([]);

  for (let i = 0; i < dates.length - 1; i++) {
    for (let j = 0; j < dataSeries.length; j++) filledDataSeries[j].push(dataSeries[j][i]);

    let currentDate = new Date(dates[i]);
    filledDates.push(currentDate);
    let nextDate = new Date(dates[i + 1]);

    // Add missing dates with 0s in dataSeries
    while ((currentDate = new Date(currentDate.setDate(currentDate.getDate() + 1))) < nextDate) {
      filledDates.push(currentDate);

      for (let j = 0; j < dataSeries.length; j++) filledDataSeries[j].push(0);
    }
  }

  filledDates.push(new Date(dates[dates.length - 1]));
  for (let j = 0; j < dataSeries.length; j++)
    filledDataSeries[j].push(dataSeries[j][dataSeries.length - 1]);

  return { dates: filledDates, dataSeries: filledDataSeries };
}

export function emailMatchesDomainListOrListEmpty(domainList: string, email: string) {
  if (!domainList || domainList.trim().length == 0) return true;

  if (!email || email.length == 0) return false;

  let emailDomain = email
    .substring(email?.indexOf("@") + 1)
    .toLowerCase()
    .trim();

  let domains = domainList?.split(",").map((d) => d?.toLowerCase().trim());

  return domains.includes(emailDomain);
}

export function emailMatchesDomainList(domainList: string, email: string) {
  if (!email || email.length == 0 || !domainList || domainList.length == 0) return false;

  let emailDomain = email
    .substring(email?.indexOf("@") + 1)
    .toLowerCase()
    .trim();

  let domains = domainList?.split(",")?.map((d) => d?.toLowerCase().trim());

  return domains.includes(emailDomain);
}
